import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import {
  IonModal,
  IonContent,
  IonSpinner,
  IonRow,
  IonCol,
  IonButton,
} from '@ionic/react';
import classes from './styles.module.scss';
import { GlobalContext } from '../../context/provider';
import { BECOMESELLER_ERROR } from '../../context/actions/types';
import { BecomeSeller } from '../../context/actions/user';
import { DeviceContext } from '../../deviceType';
import { IoMdClose } from "react-icons/io";

const BecomeASellerModal: React.FC<{
  isOpen: boolean;
  setIsOpen: (e: any) => void;
}> = ({ isOpen, setIsOpen }) => {
  const history = useHistory();
  const { userState, userDispatch } = useContext<any>(GlobalContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [becomeVendorError, setBecomeVendorError] = useState<string | null>(null);
  const device = useContext(DeviceContext);

  const onDidDismiss = () => {
    if (becomeVendorError) {
      userDispatch({ type: BECOMESELLER_ERROR, payload: null });
    }
  };

  const closeBecomeSellerModal = () => {
    setIsOpen(false);
    history.push('/dashboard/create-store');
    window.location.reload();
  };

  const handleContinue = async () => {
    setLoading(true);
    await BecomeSeller()(userDispatch);
    setLoading(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };


  useEffect(() => {
    if (userState.BecomeSeller) {
      closeBecomeSellerModal();
    }
    if (userState.BecomeSellerError) {
      const errMessage = userState.BecomeSellerError.response?.data?.message
        ?? userState.BecomeSellerError?.message;
      setBecomeVendorError(errMessage);
    }
  }, [userState.BecomeSellerError, userState.BecomeSellerError]);

  return (
    <IonModal
      className={`${device?.width < 600 && classes['mobile-modal']}
                  ${ loading && device?.width < 600 && classes['mobile-modal-loading']}
                  ${ loading && device?.width > 600 && classes['desktop-modal-loading']}`}
      isOpen={isOpen}
      canDismiss={!loading}
      onDidDismiss={onDidDismiss}
    >

      <IonContent className={classes.content}>
        <div className='w-full flex justify-end mb-2'>
            <IoMdClose
              className='text-2xl text-primary cursor-pointer '
              onClick={() => setIsOpen(false)}
            />
        </div>
        <h2 className="ion-text-center mb-8">Become a Vendor</h2>

        <div className={classes['msg-wrapper']}>
          <p>
            You are about to become a vendor on BazaarCheap. You will be able to create and manage your store(s), products and orders.
            <span className={classes['proceed-text']}> Click the button below to proceed.</span>
          </p>
        </div>

        {loading && (
          <div className={classes['msg-wrapper']}>
            <p color="secondary">Your vendor account is being set up. Please wait...</p>
            <IonSpinner name="lines" />
          </div>
        )}

        {becomeVendorError && (
          <div className={classes['msg-wrapper']}>
            <p className={classes.error}>Error: {becomeVendorError}</p>
          </div>
        )}

        <div className={classes[device?.width > 600 ? 'btns': 'desktop-btns']}>
          <IonRow>
            <IonCol>
              <IonButton shape="round" className={classes['cancel-btn']} disabled={loading} onClick={handleCancel}>Cancel</IonButton>
            </IonCol>
            <IonCol>
              <IonButton shape="round" onClick={handleContinue}>Continue</IonButton>
            </IonCol>
          </IonRow>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default BecomeASellerModal;
